import { loyaltyTeamSettingsSchema } from "@redotech/redo-loyalty-common/loyalty-definition";
import * as z from "zod/v4";

export const getLoyaltyPopupSettings = {
  name: "getLoyaltyPopupSettings" as const,
  input: z.object({}),
  output: loyaltyTeamSettingsSchema.nullable(),
};
